import { AxiosError, AxiosResponse } from "axios";
import { Dispatch } from "redux";
import { Api } from "../../../../utils/Api";
import {
  UPDATE_POST_SUCCESS,
  UPDATE_POST_FAILURE,
  UPDATE_POST_LOADER,
  UpdatePostSuccessAction,
  UpdatePostLoaderAction,
  PostActionTypes,
  Post,
} from "../types";
import { pollForLinks } from "./createPost";

export const updatePostLoader = (status: boolean): UpdatePostLoaderAction => ({
  type: UPDATE_POST_LOADER,
  payload: status,
});

export const updatePostSuccess = (data: Post): UpdatePostSuccessAction => ({
  type: UPDATE_POST_SUCCESS,
  payload: data,
});

const hasPendingLink = (links: Post["links"] | undefined): boolean =>
  (links || []).some((link) => link.status === "pending");

export const updatePost =
  (
    postId: number,
    content: string,
    removeImages?: boolean,
    linkUrls: string[] = [],
    image?: File,
  ) =>
  async (dispatch: Dispatch<PostActionTypes>): Promise<void> => {
    dispatch(updatePostLoader(true));

    const token = $('meta[name="csrf-token"]').attr("content");
    const formData = new FormData();
    formData.append("community_post[content]", content);
    if (removeImages !== undefined) {
      formData.append("community_post[remove_images]", String(removeImages));
    }
    if (image) formData.append("community_post[images][]", image);
    linkUrls.forEach((linkUrl) => formData.append("community_post[link_urls][]", linkUrl));

    new Api({})
      .put<Post, FormData>(`/api/community/posts/${postId}.json`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRF-Token": token,
        },
      })
      .then((response: AxiosResponse<Post>) => {
        dispatch(updatePostSuccess(response.data));

        if (hasPendingLink(response.data.links)) {
          pollForLinks(dispatch, response.data.id);
        }
      })
      .catch((error: AxiosError<{ error: string }>) => {
        dispatch({ type: UPDATE_POST_FAILURE, payload: error.message });
        throw error;
      })
      .finally(() => dispatch(updatePostLoader(false)));
  };
